import { createContext, useContext, useState, useCallback } from "react";

const dict = {
  en: {
    "nav.localContext": "Local Context",
    "nav.strategy": "Strategy",
    "nav.trades": "Trade Pipeline",
    "nav.seniors": "Senior Care",
    "nav.framework": "Framework",
    "nav.network": "Network",
    "nav.founder": "Founder",
    "nav.budget": "Budget",
    "nav.cdbg": "CDBG Ask",
    "nav.contact": "Contact",
    "nav.download": "Download Proposal",
    "nav.schedule": "Schedule Briefing",
    "nav.press": "Press Kit",
    "nav.pitch": "Pitch Letter",
    "lang.toggleAria": "Change language",
    "hero.eyebrow": "A Municipal Proposal · Baytown · Harris County",
    "hero.titleA": "The",
    "hero.titleB": "Baytown Bridge",
    "hero.titleC": "A multigenerational service connector initiative.",
    "hero.lead":
      "Baytown has the gears — Lee College, Harris Health, the Housing Authority, Workforce Solutions, GCCISD. What's missing is the chain. Baytown Bridge is that chain: a high-touch, multi-year case management model that walks single-mother households and aging-in-place seniors from crisis into thriving stability.",
    "hero.scheduleCta": "Schedule a Briefing",
    "hero.downloadCta": "Download Proposal PDF",
    "hero.stat1": "Baytown Poverty Rate",
    "hero.stat2": "Hispanic / Latino Residents",
    "hero.stat3": "Median Household Income",
    "hero.stat4": "Reporting Rising Housing Costs",
    "hero.statSource":
      "Verified · U.S. Census QuickFacts + City of Baytown 2025–2029 Consolidated Plan",
    "hero.scrollHint": "Scroll · The Local Context",
    "footer.tagline":
      "A multigenerational service connector initiative for Baytown and Harris County. The chain that connects Lee College, the Housing Authority, Harris Health, and Workforce Solutions into a single human relationship.",
    "footer.sections": "Sections",
    "footer.contact": "Contact",
    "footer.copyright": "Baytown Bridge · A Sterile Mate LLC Initiative",
    "footer.dataNote":
      "Verified figures from U.S. Census QuickFacts and the City of Baytown 2025–2029 Consolidated Plan. Trend lines are illustrative approximations from ACS 5-Year, TEA TAPR, and FBI UCR.",
    "sticky.fund": "Fund the Bridge",
  },
  es: {
    "nav.localContext": "Contexto Local",
    "nav.strategy": "Estrategia",
    "nav.trades": "Oficios",
    "nav.seniors": "Adultos Mayores",
    "nav.framework": "Marco",
    "nav.network": "Red",
    "nav.founder": "Fundador",
    "nav.budget": "Presupuesto",
    "nav.cdbg": "Solicitud CDBG",
    "nav.contact": "Contacto",
    "nav.download": "Descargar Propuesta",
    "nav.schedule": "Agendar Reunión",
    "nav.press": "Kit de Prensa",
    "nav.pitch": "Carta de Pitch",
    "lang.toggleAria": "Cambiar idioma",
    "hero.eyebrow": "Una Propuesta Municipal · Baytown · Condado de Harris",
    "hero.titleA": "El",
    "hero.titleB": "Puente Baytown",
    "hero.titleC": "Una iniciativa multigeneracional de conexión de servicios.",
    "hero.lead":
      "Baytown tiene los engranajes — Lee College, Harris Health, la Autoridad de Vivienda, Workforce Solutions, GCCISD. Lo que falta es la cadena. El Puente Baytown es esa cadena: un modelo de gestión de casos de alto contacto, multianual, que acompaña a madres solteras y adultos mayores desde la crisis hasta una estabilidad próspera.",
    "hero.scheduleCta": "Agendar una Reunión",
    "hero.downloadCta": "Descargar Propuesta PDF",
    "hero.stat1": "Tasa de Pobreza en Baytown",
    "hero.stat2": "Residentes Hispanos / Latinos",
    "hero.stat3": "Ingreso Familiar Medio",
    "hero.stat4": "Reportan Aumento del Costo de Vivienda",
    "hero.statSource":
      "Verificado · Censo de EE.UU. QuickFacts + Plan Consolidado 2025–2029 de la Ciudad de Baytown",
    "hero.scrollHint": "Desplazar · El Contexto Local",
    "footer.tagline":
      "Una iniciativa multigeneracional de conexión de servicios para Baytown y el Condado de Harris. La cadena que conecta Lee College, la Autoridad de Vivienda, Harris Health y Workforce Solutions en una sola relación humana.",
    "footer.sections": "Secciones",
    "footer.contact": "Contacto",
    "footer.copyright": "Puente Baytown · Una iniciativa de Sterile Mate LLC",
    "footer.dataNote":
      "Cifras verificadas del Censo de EE.UU. QuickFacts y del Plan Consolidado 2025–2029 de la Ciudad de Baytown. Las líneas de tendencia son aproximaciones ilustrativas de ACS 5-Year, TEA TAPR y FBI UCR.",
    "sticky.fund": "Financia el Puente",
  },
};

const LanguageContext = createContext({ lang: "en", setLang: () => {}, t: (k) => k });

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window !== "undefined") {
      const saved = window.localStorage.getItem("bb_lang");
      if (saved === "en" || saved === "es") return saved;
    }
    return "en";
  });

  const setLang = useCallback((next) => {
    setLangState(next);
    if (typeof window !== "undefined") window.localStorage.setItem("bb_lang", next);
  }, []);

  const t = useCallback((key) => dict[lang]?.[key] ?? dict.en[key] ?? key, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>{children}</LanguageContext.Provider>
  );
}

export function useT() {
  return useContext(LanguageContext);
}
